'use client';

export const windowReload = () => {
  window.location.reload();
};
